import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  tryFetchReportFoldersIfNeeded,
  tryFetchReportsByFolder
} from 'store/metaData/reportFolders/actions';
import Enums from 'utils/EnumsManager';
import { DraggableWrapper, Folder, Report } from './index';

const { DASHBOARD_MAX_SLOTS } = Enums.REPORTS;

const defaultProps = {};
const propTypes = {
  folders: PropTypes.array.isRequired
};

class Folders extends PureComponent {
  state = {
    activeFolderId: -1
  };
  componentDidMount() {
    this.props.tryFetchReportFoldersIfNeeded();
  }

  handleFolderClick = id => {
    this.setState(() => ({ activeFolderId: id }));
    this.props.tryFetchReportsByFolder(id);
  };

  render() {
    const { activeFolderId } = this.state;
    const { folders, slotsLength } = this.props;
    return (
      <div>
        {folders.map(f => (
          <Folder
            key={f.id}
            id={f.id}
            title={f.name}
            isActive={f.id === activeFolderId}
            onClick={this.handleFolderClick}
          >
            {f.data.map(r => (
              <DraggableWrapper
                key={r.id}
                id={r.id}
                disabled={slotsLength >= DASHBOARD_MAX_SLOTS}
              >
                <Report id={r.id} name={r.name} />
              </DraggableWrapper>
            ))}
          </Folder>
        ))}
      </div>
    );
  }
}

const mapStateToProps = ({ metaData, dashboardSettings }) => ({
  folders: metaData.reportFolders.data,
  slotsLength: dashboardSettings.details.slots.length
});
const mapDispatchToProps = {
  tryFetchReportFoldersIfNeeded,
  tryFetchReportsByFolder
};
Folders.defaultProps = defaultProps;
Folders.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Folders);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/components/Folders.jsx